import React from "react";
import { Button } from "@/components/ui/button";
import { FileText, Monitor } from "lucide-react";

interface ScreenCaptureToggleProps {
  isRecording: boolean;
  hasScreenCapture: boolean;
  recordingState: "toStart" | "Review" | "Recording" | "Done";
  onSwitchToScreenCapture?: () => void;
  history: any;
  urls: any;
  location: any;
}

export const ScreenCaptureToggle: React.FC<ScreenCaptureToggleProps> = ({
  isRecording,
  hasScreenCapture,
  recordingState,
  onSwitchToScreenCapture,
  history,
  urls,
  location,
}) => {
  if (hasScreenCapture === false) return null;

  return (
    <div className="fixed bottom-5 left-1/2 -translate-x-1/2 z-50 bg-white dark:bg-zinc-900 border border-gray-200/80 rounded-full p-1.5 shadow-xl flex gap-1 select-none animate-in fade-in duration-200">
      <Button
        size="sm"
        className="font-semibold bg-teal-500/10 hover:bg-teal-500/20 text-teal-600 border-0 h-8 rounded-full"
      >
        <FileText className="size-4 mr-2" /> Teleprompter
      </Button>
      <Button
        size="sm"
        variant="ghost"
        className="font-semibold text-gray-500 hover:text-gray-900 h-8 cursor-pointer rounded-full"
        disabled={isRecording}
        onClick={() => {
          if (
            recordingState !== "toStart" &&
            !window.confirm("Switching modes will clear your current progress. Are you sure?")
          ) {
            return;
          }
          if (onSwitchToScreenCapture) {
            onSwitchToScreenCapture();
          } else {
            history.replace(urls.screenCapture, location.state);
          }
        }}
      >
        <Monitor className="size-4 mr-2" /> Screen Record
      </Button>
    </div>
  );
};
